const SUBMISSION = 'submission'
const VOTING = 'voting'
const RESULT = 'result'

export default {
  SUBMISSION,
  VOTING,
  RESULT,
}
